import validators from '../../utils/validators';
import StrategyGoal from './goal';

class StrategyStage {
  /**
   * @param data
   */
  constructor(data) {
    const properties = {
      id: (v) => validators.isNotEmptyString(v),
      user: (v) => validators.isNotEmptyString(v),
      title: (v) => validators.isStringOrNull(v),
      note: (v) => validators.isStringOrNull(v),
      dateTo: (v) => validators.isStringOrNull(v),
      dateFrom: (v) => validators.isStringOrNull(v),
    };

    this.goals = [];
    this.finished = false;

    for (const property of Object.keys(properties)) {
      if (properties[property](data[property]) !== true) {
        throw new Error(`Invalid StrategyStage property '${property}' in ${data.id}`);
      }

      if (['dateFrom', 'dateTo'].includes(property)) {
        if (typeof data[property] === 'string' && data[property].trim() !== '') {
          this[property] = new Date(data[property]);
        }
      } else {
        this[property] = data[property];
      }
    }

    if (!Array.isArray(data.goals)) {
      throw new Error(`Invalid StrategyStage property 'goals' in ${data.id}`);
    }

    let hasUnfinished = false;

    for (const goal of data.goals) {
      const stageGoal = new StrategyGoal(goal);

      hasUnfinished = stageGoal.isUnfinished() ? true : hasUnfinished;

      this.goals.push(stageGoal);
    }

    this.finished = !hasUnfinished;
  }
}

export default StrategyStage;
